import { render, staticRenderFns } from "./V3NavEditor.vue?vue&type=template&id=0f9c67c0&scoped=true"
import script from "./V3NavEditor.vue?vue&type=script&lang=js"
export * from "./V3NavEditor.vue?vue&type=script&lang=js"
import style0 from "./V3NavEditor.vue?vue&type=style&index=0&id=0f9c67c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9c67c0",
  null
  
)

export default component.exports